import api from './client';

// Wealth API
export const wealthAPI = {
  getAssets: (entityId) => api.get('/wealth/assets', { params: { entity_id: entityId } }),
  getSummary: (entityId) => api.get('/wealth/summary', { params: { entity_id: entityId } }),
  getHistory: (months = 12) => api.get('/wealth/history', { params: { months } }),
};

// Assets & Liabilities API
export const assetsLiabilitiesAPI = {
  getCategories: () => api.get('/al/categories'),
  createCategory: (data) => api.post('/al/categories', data),
  updateCategory: (key, data) => api.put(`/al/categories/${key}`, data),
  getItems: (scope, entityId) => api.get('/al/items', { params: { scope, entity_id: entityId } }),
  createItem: (data) => api.post('/al/items', data),
  updateItem: (id, data) => api.put(`/al/items/${id}`, data),
  deleteItem: (id) => api.delete(`/al/items/${id}`),
  appendValuation: (id, data) => api.post(`/al/items/${id}/valuations`, data),
  getMonthlySeries: (scope, entityId, displayCurrency, months = 12) =>
    api.get('/al/monthly-series', { params: { scope, entity_id: entityId, display_currency: displayCurrency, months } }),
  getNetAssetsSeries: (scope, entityId, displayCurrency, months = 24, calendarYear = false) =>
    api.get('/al/net-assets-series', { params: { scope, entity_id: entityId, display_currency: displayCurrency, months, calendar_year: calendarYear } }),
  takeSnapshot: (scope, entityId, month) =>
    api.post('/al/snapshots', null, { params: { scope, entity_id: entityId, month } }),
  migrateWealth: () => api.post('/al/migrate-wealth'),
  getBalanceSheet: (scope, entityId, displayCurrency) =>
    api.get('/al/balance-sheet', { params: { scope, entity_id: entityId, display_currency: displayCurrency } }),
  getEntriesSection: (section, scope, entityId, displayCurrency, page = 1, pageSize = 100) =>
    api.get(`/al/entries/${section}`, {
      params: { scope, entity_id: entityId, display_currency: displayCurrency, page, page_size: pageSize },
    }),
  getEntriesSectionCsv: (section, scope, entityId, displayCurrency) =>
    api.get(`/al/entries/${section}`, {
      params: { scope, entity_id: entityId, display_currency: displayCurrency, format: 'csv' },
      responseType: 'blob',
    }),
};

// Portfolio API (Real Estate)
export const portfolioAPI = {
  get: (params) => api.get('/reports/portfolio', { params }),
  getMonthly: async (params) => {
    const { year } = params || {};
    const qs = new URLSearchParams();
    if (year) qs.set('year', year);
    const res = await api.get(`/reports/portfolio/monthly?${qs.toString()}`);
    return res.data;
  },
  getDashboard: async (params) => {
    const { year } = params || {};
    const qs = new URLSearchParams();
    if (year) qs.set('year', year);
    const res = await api.get(`/reports/portfolio/dashboard?${qs.toString()}`);
    return res.data;
  },
  getPnl: async (params) => {
    const { year } = params || {};
    const qs = new URLSearchParams();
    if (year) qs.set('year', year);
    const res = await api.get(`/reports/portfolio/pnl?${qs.toString()}`);
    return res.data;
  },
  getVisitorLevy: async (year) => {
    const res = await api.get('/reports/visitor-levy', { params: year ? { year } : {} });
    return res.data;
  },
  getDataset: async (params) => {
    const { year } = params || {};
    const qs = new URLSearchParams();
    if (year) qs.set('year', year);
    const res = await api.get(`/reports/portfolio/dataset?${qs.toString()}`);
    return res.data;
  },
  // 2026-07-20 managed-property gross-revenue restatement diagnostic:
  // before/after monthly UK/FR revenue comparing the pre-fix fee-basis
  // formula against the current gross-basis formula.
  getManagedGrossRestatement: async (params) => {
    const { year } = params || {};
    const qs = new URLSearchParams();
    if (year) qs.set('year', year);
    const res = await api.get(`/admin/diagnostics/managed-gross-restatement?${qs.toString()}`);
    return res.data;
  },
};

// Asset Register API (per-entity assets & liabilities)
export const assetRegisterAPI = {
  list: (entityId) => api.get('/asset-register', { params: { entity_id: entityId } }),
  summary: (entityId) => api.get('/asset-register/summary', { params: { entity_id: entityId } }),
  create: (data) => api.post('/asset-register', data),
  update: (id, data) => api.put(`/asset-register/${id}`, data),
  delete: (id) => api.delete(`/asset-register/${id}`),
};

// Portfolio Properties API (property exclusion toggles on IntegrationsPage)
export const portfolioPropertiesAPI = {
  getAll: () => api.get('/integrations/portfolio-properties'),
  update: (propertyId, data) =>
    api.patch(`/integrations/portfolio-properties/${propertyId}`, data),
};
